import { createRoot } from "react-dom/client";
import { pdfjs } from "react-pdf";

import { ApolloProvider } from "@apollo/client";
import "moment/locale/nb";

import apolloClient from "graphql/apolloClient";
import { AnalyticsProvider } from "providers/Analytics";
import { AuthProvider } from "providers/Authentication";
import { ErrorLoggerProvider } from "providers/ErrorLogger";
import TailwindProvider from "providers/Tailwind";
import IntlProvider from "providers/i18n";
import { installChunkErrorRecovery } from "utils/chunkReload";

import App from "./App";
import "./index.css";

// Auto-recover from stale-bundle white screens after a deploy (see
// utils/chunkReload). Must run before any lazy chunk loads.
installChunkErrorRecovery();

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;

const container = document.getElementById("root");
const app = (
  <AnalyticsProvider>
    <TailwindProvider>
      <ErrorLoggerProvider>
        <ApolloProvider client={apolloClient}>
          <AuthProvider>
            <IntlProvider>
              <App />
            </IntlProvider>
          </AuthProvider>
        </ApolloProvider>
      </ErrorLoggerProvider>
    </TailwindProvider>
  </AnalyticsProvider>
);

if (container) createRoot(container).render(app);
